exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".analyze-analysis{margin-top:-20px;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.analyze-analysis_heading{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-bottom:5px}.analyze-analysis_heading_txt1{font-size:18px;font-weight:400}.analyze-analysis_model_options{cursor:pointer;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center;padding:5px}.analyze-analysis_model_options div{padding-bottom:5px}.analyze-analysis_model_options:hover{color:var(--primary-dark-blue)}.analyze-analysis_model_options_active{border-bottom:3px solid var(--primary-dark-blue)}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/pages/Create/universe_lite/Analyze/analysis/AnalyzeAnalysis.styles.scss
// module id = 1467
// module chunks = 0